import { Component, inject, OnInit } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ScopedProject } from "@domain/project/project-guards";
import { ProjectImageService, SyncState } from "@domain/project/project-image.service";
import { ProjectService } from "@domain/project/project.service";
import { Modal, ModalRef } from "@odx/angular/components/modal";
import { map, Observable, switchMap } from "rxjs";
import { ProjectImageMetadata } from "../../domain/project/project-image-metadata";

@Component({
  templateUrl: "./file-modal.component.html",
  styleUrls: ["./file-modal.component.scss"],
  imports: [UiKitModule],
})
export class FileModalComponent implements Modal<any, string>, OnInit {
  public readonly modalRef = inject(ModalRef<any, string>);
  private projectService = inject(ProjectService);
  private projectImageService = inject(ProjectImageService);
  protected readonly navigator = navigator;

  headerText!: string;
  fileName!: string;
  fileUrl$!: Observable<string>;
  imageMetadata!: ProjectImageMetadata;
  project!: ScopedProject;

  ngOnInit(): void {
    this.project = this.modalRef.data.project;
    this.fileUrl$ = this.projectImageService.getImageSyncStatus(this.modalRef.data.imageMetadata.id).pipe(
      switchMap((syncState) => {
        if (syncState === SyncState.NEW || !navigator.onLine) {
          return this.projectImageService
            .getOriginalImageFromIndexedDB(this.modalRef.data.imageMetadata.id)
            .pipe(map((image: Blob) => URL.createObjectURL(image)));
        } else {
          return this.projectImageService
            .loadImage(this.project.cloudId!, this.modalRef.data.imageMetadata.id)
            .pipe(map((image: Blob) => URL.createObjectURL(image)));
        }
      }),
    );

    this.imageMetadata = this.modalRef.data.imageMetadata;
    this.fileName = this.imageMetadata.name;
    this.headerText = this.modalRef.data.headerTexxt ?? this.imageMetadata.name;
  }
}
